/**
 * Beaute Plus — vertical thumbnail navigation
 * Desktop (≥990px): prev/next buttons scroll the .thumbnail-list vertically.
 *
 * Dawn's SliderComponent attaches click handlers in its constructor (during
 * custom-element upgrade). It calls scrollTo({ left }) — horizontal only.
 * To prevent Dawn's handler from interfering, we CLONE the buttons (which
 * removes all attached event listeners), then attach our own vertical handlers.
 *
 * Strategy:
 *  1. Wait until DOM is parsed (defer ensures this).
 *  2. For each thumbnail-slider in product--thumbnail layout:
 *     a. Replace prev/next buttons with clones (drops Dawn's listeners).
 *     b. Attach our own click → scrollBy({ top }) handlers.
 *     c. Update disabled state on scroll.
 */
(function () {
  const ITEM_HEIGHT = 72;
  const GAP = 8;
  const SCROLL_STEP = (ITEM_HEIGHT + GAP) * 3; // 3 items per click

  function setupSlider(slider) {
    if (slider.dataset.bpInit === '1') return; // idempotent
    slider.dataset.bpInit = '1';

    const list = slider.querySelector('.thumbnail-list');
    let prevBtn = slider.querySelector('.slider-button--prev');
    let nextBtn = slider.querySelector('.slider-button--next');
    if (!list || !prevBtn || !nextBtn) return;

    // Replace buttons with clones to drop Dawn's listeners.
    const prevClone = prevBtn.cloneNode(true);
    const nextClone = nextBtn.cloneNode(true);
    prevBtn.parentNode.replaceChild(prevClone, prevBtn);
    nextBtn.parentNode.replaceChild(nextClone, nextBtn);
    prevBtn = prevClone;
    nextBtn = nextClone;

    function updateDisabled() {
      const maxScroll = Math.max(0, list.scrollHeight - list.clientHeight);
      const atTop = list.scrollTop <= 0;
      const atBottom = list.scrollTop >= maxScroll - 1;
      prevBtn.toggleAttribute('disabled', atTop);
      nextBtn.toggleAttribute('disabled', atBottom);
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      list.scrollBy({ top: -SCROLL_STEP, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      list.scrollBy({ top: SCROLL_STEP, behavior: 'smooth' });
    });

    list.addEventListener('scroll', updateDisabled, { passive: true });
    // Defer to next frame so layout is final
    requestAnimationFrame(updateDisabled);
    // Also after a short delay (in case images load and change scrollHeight)
    setTimeout(updateDisabled, 500);
  }

  function initAll() {
    document
      .querySelectorAll(
        '.product--thumbnail .thumbnail-slider, .product--thumbnail_slider .thumbnail-slider'
      )
      .forEach(setupSlider);
  }

  // Multiple init points for robustness (defer + DOMContentLoaded + load + Shopify lifecycle)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();
